import { render } from "./z-delete-task-modal.vue?vue&type=template&id=69a1b060"
import script from "./z-delete-task-modal.vue?vue&type=script&lang=js"
export * from "./z-delete-task-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__